// l10n status: done
import { useCallback, useEffect, useState, memo, useMemo } from "react"
import ffAd_RedCircle from "img/player/ffAd_RedCircle.svg"
// MTVW-1101
import ffAd_WhiteCircle from "img/player/ffAd_WhiteCircle.svg"
import ffAd_icon from "img/player/ffAd_icon.svg"
// MTVW-1101
import ffAd_RedIcon from "img/player/ffAd_RedIcon.svg"
import next_episodeIcon from "img/player/next_episode.svg"
import close_nextEpisode from "img/player/close_nextEpisode.svg"
import { l10n } from "store/lang/L10n"
import { observer } from "mobx-react"
import IconButton from "@mui/material/IconButton"
import { useResize } from "hooks/useResize"
import { startTs, endTs, eventId } from "utils/EventHelpers"
import { moment } from "store/util/moment"
import { TIME_FORMAT_BACKEND } from "store/model/Time"
import { appFeatures } from "AppFeatures"
import { SourceTypeList } from "store/page/player/source/SourceTypeList"
import { analyticsEvent, analyticsMeta } from "store/qlapi/LogService"
import classnames from "classnames"
import "./ffAdAnimatedIcon.css"

// MTVW-1101
const ButtonNextEpisode = ({ label, onClick}) => {
	const [open, setOpen] = useState(true)

	return (
		<div className={classnames("nextEpisodeGroupContainer", { "visible": open, "hidden": !open })}>
            {/* Left Icon */}
				<div className="nextEpisodeCloseButton"
				   onClick={(e) => {
                  e.stopPropagation()
                  setOpen(false)
               }}
				>
					<img className="nextEpisodeButtonSvg"
						src={close_nextEpisode}>
					</img>
				</div>

			<div id="bNextEpisode" className={classnames("nextEpisodeButton" ,
				 { "visible": open,
					"hidden": !open })}  data-test="buttonNextEpisode"
            onClick={onClick}
         >

            {/* Middle Label */}
            <div className="nextEpisodeButtonLabel" style={{textIndent: 20}}>
               {label}
            </div>

            {/* Right Side */}
            <div className="nextEpisodeButtonIconRight">
					<img className="nextEpisodeButtonSvg"
						src={next_episodeIcon}>
					</img>
            </div>
         </div>
      </div>
	)
}

// MTVW-1101
const ButtonNextEpisodeInControls = ({ label, onClick, nextButtonBeforeEnd = null, nextButtonInControls = null, isControlsVisible = null }) => {
   // Logic to determine if it should be visible right now
   const isCurrentlyVisible = nextButtonInControls || (nextButtonBeforeEnd && !isControlsVisible)

   // Track if the button has ever been displayed to avoid "fade-out on page load"
   const [hasAppeared, setHasAppeared] = useState(false)

   useEffect(() => {
		//console.debug("useEffect visibility", isCurrentlyVisible, nextButtonInControls, nextButtonBeforeEnd, isControlsVisible)
      if (isCurrentlyVisible) setHasAppeared(true)
   }, [isCurrentlyVisible])

   return (
		<div className="nextEpisodeButtonContainer">
         <div
				id="ButtonNextEpisodeInControls"
            className={classnames("nextEpisodeInfo", {
               "visible": isCurrentlyVisible,
               "hidden": !isCurrentlyVisible && hasAppeared // Only hide if it was once shown
            })}
            data-test="nextEpisodeInfo"
				style={{
					cursor: nextButtonBeforeEnd ? "" : "",//"none",
               pointerEvents: nextButtonBeforeEnd ? "none" : "auto",
               backgroundColor: nextButtonBeforeEnd ? "rgba(26, 26, 26, 0.95)" : "#D40037"
				}}
            //onClick={onClick}
				onClick={(e) => {
					onClick(e, analyticsMeta.control)
				}}
         >
            <div className="nextEpisodeInfoLabel">{label}</div>
            <div className="nextEpisodeButtonIconRight">
					<img className="nextEpisodeButtonSvg" src={next_episodeIcon} alt="next" />
            </div>
         </div>
      </div>
)
}
	
const PlayerActionButton = memo(({id, className, text, style, nextButtonInControls, nextButtonBeforeEnd, nextButton,
											 isControlsVisible, isFullScreen, isFullScreenCinema, source, onNextEpisodeClick,
											 width}) => {
 
	//console.debug("PlayerActionButton", id)
	const controlsClass = isControlsVisible
	  ? isFullScreen
		 ? "" //"fastForwardContainerControlsOnFullscreen"
		 : "fastForwardContainerControlsOn"
	  : ""
 
	const handleSkip = (e) => {
	  e.stopPropagation()
	  source.skipAd()
	}
 
	const handleTouch = (e) => {
	  e.stopPropagation()
	  e.preventDefault()
	  source.skipAd()
	}

	//console.debug("PlayerActionButton", id, className, nextButtonInControls, nextButton, onNextEpisodeClick)
 
	return (
	  <div	  
		 id={id}
		 style={style}
		 className={`${className} ${controlsClass}`}
		 onClick={!nextButtonInControls && !nextButton ? handleSkip : undefined}
	  >
		 <div className="linearSkipContent">
 
			{(nextButtonInControls || nextButtonBeforeEnd) && (
				<ButtonNextEpisodeInControls
					label={nextButtonBeforeEnd ? l10n.featurePlayerNextEpisodeAvailable : l10n.featurePlayerNextEpisode}
					/*
					onClick={() => {}}
					*/
					onClick={onNextEpisodeClick}
					nextButtonBeforeEnd={nextButtonBeforeEnd}
					nextButtonInControls={nextButtonInControls}
					isControlsVisible={isControlsVisible}
				/>
			)}
			{nextButton && (
			  <ButtonNextEpisode
				 label={l10n.featurePlayerNextEpisode}
				 onClick={onNextEpisodeClick}
			  />
			)}
			{!nextButtonInControls && !nextButton && !nextButtonBeforeEnd && (
			  <>
				<div className={id === "fastForwardIcon" ? "fastForwardText" : "linearSkipText"}>
					{text}
				</div>
 
				<div className="fastForwardRedCircle">
					<img src={ffAd_WhiteCircle} alt="" style={{width: "100%", height: "100%"}}/>
					<div className="fastForwardWhiteIcon">
						<img src={ffAd_RedIcon} alt="" style={{width: "100%", height: "100%"}}/>
					</div>
				</div>
			  </>
			)}
 
		 </div>
	  </div>
	)
 })

/*
const ButtonsPresenter = memo(({buttons, isControlsVisible, mode, source, onNextEpisodeClick}) => {
	// This log should only trigger when buttons actually change
	console.debug("ButtonsPresenter Render: Visibility/Mode Change")
 
	return (
	  <div className={`buttonsContainer ${mode()} ${isControlsVisible ? "isVisible" : ""}`}>
		 {buttons.map((btn) => (
			<PlayerActionButton
			  key={btn.id}
			  {...btn}
			  isControlsVisible={isControlsVisible}
			  source={source}
			  onNextEpisodeClick={onNextEpisodeClick}
			/>
		 ))}
	  </div>
	)
})
*/

export const PositionStateMonitorUi = observer(({ page, adStyleValidCounter, adStyleInfo, isControlsVisible, isFullScreen, isFullScreenCinema}) => {
	// MTVW-727: don't show if in PiP
	//if (page.player.isInPip) return null

	const [showButtons, setShowButtons] = useState(true)

	useEffect(() => {
		return () => {
			page.source.resetlatchedEpisodeInfo()
		}
	}, [/*page.source*/])

	const size = useResize(rootStore.page.Player.tvRef, { throttleMs: 20 }, ({ width, height }) => {
		//console.debug("useResize")
		//setAdStyles()
	})
	//console.debug("isLoading=", page.player.isLoading, page.player.isStreamLoaded, page.source.nextEpisodeInfo?.end)
	const source = page.source
	const positionTimeStamp = page.player.positionTimeStamp
	const nextEpisodeInfo = source.nextEpisodeInfo
	//console.debug("nextEpisodeInfo", moment(nextEpisodeInfo?.start).utc().format(TIME_FORMAT_BACKEND), moment(nextEpisodeInfo?.end).utc().format(TIME_FORMAT_BACKEND), nextEpisodeInfo?.nextEpisodeId)

	//source.checkNonBvChannel()


	/* -------------------- UI STATE -------------------- */

	const {ffAd, skipAd, nextEpisodeButton, nextEpisodeBeforeEnd, nextEpisodeInPlayerControls} = useMemo(() => {

		const ffAd = page.source.adState?.linear && !page.source.adState?.linear.skip

		const skipAd = page.source.adState?.linear?.skip

		const nextEpisodeButton = appFeatures.persistedNextEpisode && page.player.isStreamLoaded &&
			positionTimeStamp >= nextEpisodeInfo?.start &&
			positionTimeStamp <= nextEpisodeInfo?.end

		let nextEpisodeBeforeEnd = false
		//if (((nextEpisodeInfo?.start && nextEpisodeInfo?.end) || nextEpisodeInfo?.nextEpisodeId) && page.source.Event) {
		if (appFeatures.persistedNextEpisode && !isControlsVisible && page.player.isStreamLoaded && nextEpisodeInfo?.nextEpisodeId && page.source.Event) {
			const beforeEndTime = 5 * 60 * 1000 // 5 minutes
			const beforeEndDuration = 5000 // 5 seconds

			let beforeEnd = endTs(page.source.Event) - beforeEndTime
			if (nextEpisodeInfo.start) beforeEnd = nextEpisodeInfo.start - beforeEndTime
			let afterBeforeEnd = beforeEnd + beforeEndDuration
			afterBeforeEnd = beforeEnd + beforeEndDuration
			//console.debug("nextEpisodeInfo end", moment(nextEpisodeInfo.end).utc().format(TIME_FORMAT_BACKEND), "beforeEnd", moment(beforeEnd).utc().format(TIME_FORMAT_BACKEND), "afterBeforeEnd", moment(afterBeforeEnd).utc().format(TIME_FORMAT_BACKEND))
			if (beforeEnd && afterBeforeEnd) {
				nextEpisodeBeforeEnd = positionTimeStamp >= beforeEnd &&	positionTimeStamp < afterBeforeEnd
			}
		}

		let nextEpisodeInPlayerControls = false
		if (appFeatures.persistedNextEpisode) {
			if (!nextEpisodeBeforeEnd && isControlsVisible && nextEpisodeInfo?.start && nextEpisodeInfo?.end && page.source.Event) {
				nextEpisodeInPlayerControls = page.player.isStreamLoaded &&
					positionTimeStamp < nextEpisodeInfo?.start &&
					positionTimeStamp > startTs(page.source.Event) + (endTs(page.source.Event) - startTs(page.source.Event)) / 2
			}
			else if (isControlsVisible && nextEpisodeInfo?.nextEpisodeId && page.source.Event) {
				nextEpisodeInPlayerControls = page.player.isStreamLoaded &&
					positionTimeStamp < endTs(page.source.Event) &&
					positionTimeStamp > startTs(page.source.Event) + (endTs(page.source.Event) - startTs(page.source.Event)) / 2
			}
		}

		return {ffAd, skipAd, nextEpisodeButton, nextEpisodeBeforeEnd, nextEpisodeInPlayerControls}

	}, [page.source.adState?.linear, page.source.Event, positionTimeStamp, nextEpisodeInfo?.start, nextEpisodeInfo?.end, nextEpisodeInfo?.nextEpisodeId, isControlsVisible])


	/* -------------------- STYLES -------------------- */

	const ffAdIconStyle = useMemo(() => {
		if (!isFullScreen || adStyleValidCounter <= 0) return {}

		const right = adStyleInfo?.videoRight //+ 32

		const bottom = isControlsVisible
			? "" //adStyleInfo?.videoBottomOffset + (isFullScreenCinema ? 106 : 166)
			: "" //adStyleInfo?.videoBottomOffset //+ 22

		//console.debug("ffAdIconStyle", right, bottom)

		return { right, bottom }

	}, [isFullScreen, adStyleValidCounter, isControlsVisible, isFullScreenCinema, adStyleInfo?.videoRight, adStyleInfo?.videoBottomOffset])

	// adZone end is jump position
	//if (source.adState?.linear) console.debug("adState linear", source.adState?.linear, source.adZone, source.adZone?.end, source)
	//if (source.adState?.fastFwd) console.debug("adState fastFwd", source.adState?.fastFwd, source.adZone, source.adZone?.end, source)
	//if (source.adState?.replay) console.debug("adState replay", source.adState?.replay, source.adZone, source)
	/*
	if (skipAd && source.adZone?.end) {
		console.debug("adState linear", Number(source.adZone?.end) >= Number(source.Event?.event?.endMillis), moment(Number(source.adZone?.end)).utc().format(TIME_FORMAT_BACKEND), moment(Number(source.Event?.event?.endMillis)).utc().format(TIME_FORMAT_BACKEND))
	}
	*/
	//console.debug("uiStates", ffAd, skipAd, nextEpisodeButton, page.source.contentEndPosition, page.source.Event?.nextEpisodeId, page.source)

	const nextIconStyle = useMemo(() => {

		const right = adStyleInfo?.videoRight //+ 10

		if (!isFullScreen) {
			return {
				right,
				bottom: isControlsVisible
					? ""
					: "" //adStyleInfo?.videoBottomOffset //+ 22
			}
		}

		let bottom

		if (isControlsVisible) {
			bottom = !isFullScreenCinema
				? "" //adStyleInfo?.videoBottomOffset //+ 96 + 66 + 44
				: "" //adStyleInfo?.videoBottomOffset //+ 96 + 32
		} else {
			bottom = !isFullScreenCinema
				? "" //adStyleInfo?.videoBottomOffset //+ 66
				: "" //adStyleInfo?.videoBottomOffset //+ 22
		}

		//console.debug("nextIconStyle", isControlsVisible, adStyleInfo?.videoRight, right, adStyleInfo?.videoBottomOffset, bottom)

		return { right, bottom }

	}, [isFullScreen, isControlsVisible, isFullScreenCinema, adStyleInfo?.videoRight, adStyleInfo?.videoBottomOffset])


	const buttonsContainerStyle = useMemo(() => {
		return {
			transition: nextEpisodeInPlayerControls && !(ffAd || skipAd)
				? "none"
				: ""
		}
	}, [nextEpisodeInPlayerControls, ffAd, skipAd])


	const mode = useMemo(() => {
		if (isFullScreenCinema) return "cinema"
		if (isFullScreen) return "fullScreen"
		return "standard"
	}, [isFullScreenCinema, isFullScreen])


	/* -------------------- MEASURE TEXT -------------------- */

	useEffect(() => {
		let textWidth = document.getElementById("skipAdText")?.getBoundingClientRect()?.width
		const el = document.querySelector(".varSelector")
		let adWidth = textWidth ? textWidth + 52 : null
		if (el && adWidth && textWidth) {
			if (textWidth) el.style.setProperty("--target-skipAd-width", `${adWidth}px`)
			console.debug("skipAdText width %s", adWidth, el)
		}
		textWidth = document.getElementById("ffAdText")?.getBoundingClientRect()?.width
		adWidth = textWidth ? textWidth + 52 : null
		if (el && adWidth && textWidth) {
			if (textWidth) el.style.setProperty("--target-ffAd-width", `${adWidth}px`)
			console.debug("ffAdText width %s", adWidth, el)
		}
		textWidth = document.getElementById("nextEpisodeText")?.getBoundingClientRect()?.width
		adWidth = textWidth ? textWidth + (size.width > 640 ? 82 : size.width > 360 ? 52 : 42) : null
		if (el && adWidth && textWidth) {
			el.style.setProperty("--target-nextEpisode-width", `${adWidth}px`)
			console.debug("nextEpisodeText width %s", adWidth, el, size.width)
		}
		textWidth = document.getElementById("nextEpisodeHint")?.getBoundingClientRect()?.width
		adWidth = textWidth ? textWidth + (size.width > 640 ? 46 : size.width > 360 ? 40 : 34) : null
		if (el && adWidth && textWidth) {
			el.style.setProperty("--target-nextEpisode-hint-width", `${adWidth}px`)
			console.debug("nextEpisodeHint width %s", adWidth, el, size.width)
		}

		const buttonsContainer = document.getElementById("buttonsContainer")
		console.debug("buttonsContainer baseBottom", buttonsContainer?.dataset.baseBottom)
		if (buttonsContainer && buttonsContainer?.dataset.baseBottom === undefined) {
			//buttonsContainer.style.transform = 'none'
			const baseRect = buttonsContainer.getBoundingClientRect()
			buttonsContainer.dataset.baseBottom = baseRect.bottom
		}
	}, [ffAd, skipAd, nextEpisodeBeforeEnd, nextEpisodeInPlayerControls, nextEpisodeButton, size.width/*, size.height*/])


	/* -------------------- HANDLERS -------------------- */

	const onNextEpisodeClick = useCallback((e, analyticsType = analyticsMeta.player) => {
		e?.stopPropagation()
		e?.preventDefault()

		const logMediaType = page.source?.type === SourceTypeList.ChannelLive ? analyticsMeta.live :
			page.source?.type === SourceTypeList.ContentPlaylist ? analyticsMeta.recording : analyticsMeta.replay
		const logMeta = {
			[analyticsType]: analyticsMeta.nextEpisode,
			[analyticsMeta.mediaType]: logMediaType
		}
		//console.debug("onNextEpisodeClick", analyticsType,page.source?.type, logMeta)

		///setShowButtons(false)
		const nextEpisodeId = source.latchedEpisodeInfo?.nextEpisodeId
		page.source.resetlatchedEpisodeInfo()

		//console.debug("onNextEpisodeClick1", isFullScreen, isFullScreenCinema)
		if (nextEpisodeId) {
			const evtId = eventId(source.Event.event)
			//console.debug("NEXT EPISODE CLICKED", evtId, nextEpisodeId, source)
			// MTVW-1101: temporarily delete bookmarks
			///rootStore.page.CoCoBookmarks.deleteBookmarkAsync(null, nextEpisodeId).then((res) => {
				rootStore.logService.analyticsPlayerControlTap(logMeta)
				rootStore.page.OverlayEventDetails.setEpgEventById(nextEpisodeId, true,
					/*{ [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.miniEpg }*/
					null, true) // keepScreenState
					/*
					.then((res) => {
						setTimeout(() => {
							rootStore.page.CoCoBookmarks.deleteBookmarkAsync(null, evtId)
						}, 10000)
					})
					.finally(() => {
						setShowButtons(true)
					})
					*/
			///})
		}
	}, [source, page])


	/* -------------------- BUTTON MODEL -------------------- */

	const buttons = useMemo(() => {

		const b = []

		nextEpisodeBeforeEnd && b.push({
			id: "nextEpisode-beforeEnd",
			className: "nextEpisodeButtonContainer",
			style: nextIconStyle,
			nextButtonBeforeEnd: true
		})

		nextEpisodeInPlayerControls && b.push({
			id: "nextEpisode-controls",
			className: "nextEpisodeButtonContainer",
			style: nextIconStyle,
			nextButtonInControls: true
		})

		nextEpisodeButton && b.push({
			id: "nextEpisode-button",
			className: "nextEpisodeButtonContainer",
			style: nextIconStyle,
			nextButton: true
		})

		ffAd && b.push({
			id: "fastForwardIcon",
			className: "fastForwardContainer",
			text: l10n.featurePlayerShortAds,
			style: ffAdIconStyle
		})

		skipAd && b.push({
			id: "linearSkip",
			className: "linearSkipContainer",
			text: l10n.featurePlayerSkipAds,
			style: ffAdIconStyle
		})

		return b

	}, [nextEpisodeBeforeEnd, nextEpisodeInPlayerControls, nextEpisodeButton, ffAd, skipAd, ffAdIconStyle, nextIconStyle])


	/* -------------------- RENDER -------------------- */

	if (!page.player.isStreamLoaded || !showButtons) return null

	return (
		<div className="varSelector">
				{/* invisible measurement divs */}
			<div className="linearSkipContainer" style={{ zIndex: 0, height: 0 }}>
				<div id="skipAdText" className="linearSkipText" style={{ width: "auto", height: 0 }}>
					{l10n.featurePlayerSkipAds}
				</div>
				<div	id="ffAdText" className="linearSkipText" style={{ width: "auto", height: 0 }}>
					{l10n.featurePlayerShortAds}
				</div>
				<div id="nextEpisodeText" className="linearSkipText" style={{ width: "auto", height: 0 }}>
					{l10n.featurePlayerNextEpisode}
				</div>
				<div id="nextEpisodeHint" className="linearSkipText" style={{ width: "auto", height: 0 }}>
					{l10n.featurePlayerNextEpisodeAvailable}
				</div>
			</div>
	
			<div className={`buttonsContainer ${mode} ${isControlsVisible ? "isVisible" : ""}`}
					id="buttonsContainer"
					style={buttonsContainerStyle}>
					{buttons.map(btn => (
						<PlayerActionButton
							key={btn.id}
							{...btn}
							isControlsVisible={isControlsVisible}
							isFullScreen={isFullScreen}
							isFullScreenCinema={isFullScreenCinema}
							source={source}
							onNextEpisodeClick={onNextEpisodeClick}
							width={size.width}
						/>
					))}
			</div>
		</div>
	 )
})
